module.exports = {
  config: {
    isDemo: false,
    prodAppServerHost: '',
    prodAppServerPort: 3000,
    devApiProtocol: 'http',
    prodApiProtocol: 'https',
    devApiHost: 'localhost:8080',
    prodApiHost: 'cmsapi.americas.wegoshare.com',
  },
}


//////////////////
// WEBPACK FOOTER
// ./config.js
// module id = 803
// module chunks = 0